import { Helper } from "../core/util/helper";
import React from "react";
export default class ShortCutInfoText extends React.Component<any, any> {

    private values: ShortCutInfo[] = [];
    private translation: string[];
    private  keyBoardStyle: React.CSSProperties = {
        background: "#f9f9f9",
        border: "1px solid #aaa",
        borderRadius: "2px",
        boxShadow: "1px 2px 2px #ddd",
        fontFamily: "inherit",
        fontSize: "15px",
        padding: "0 8px",
        margin: "5px",
        height: "25px",
        width: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    private spanStyle: React.CSSProperties = {
        marginRight: "5px"
    }

    constructor(props) {
        super(props);
        const handleEval: (action) => boolean = props.handleEval;
        this.translation = props.context.translations;
        const values: ShortCutInfo[] = this.props.field.props.values;
        this.values = values.filter((item) => {
            switch (typeof item.visible) {
                case "string":
                    return handleEval(item.visible);
                case "boolean":
                    return item.visible as boolean;
            }

        });
    }

    private createShortCut = (shortCut: string) => {
        let keys = shortCut.split(" ").filter(f => !Helper.isNullOrEmpty(f));
        const el = keys.map((s) => {
            switch (s.trim()) {
                case ("->"):
                    return (
                        <React.Fragment key={kendo.guid()}>
                            <span style={this.spanStyle}>{this.translation["WebSMS.Help.ShortCuts.Then"]}</span>
                        </React.Fragment>
                    );
                case ("+"):
                    return (
                        <React.Fragment key={kendo.guid()}>
                            <span style={this.spanStyle}>{this.translation["WebSMS.Help.ShortCuts.And"]}</span>
                        </React.Fragment>
                    );
                case "<":
                    return (
                        <kbd style={this.keyBoardStyle} key={kendo.guid()}>
                            {"<-"}
                        </kbd>
                    );
                case ">":
                    return (
                        <kbd style={this.keyBoardStyle} key={kendo.guid()}>
                            {"->"}
                        </kbd>
                    );
                default:
                    s = s.replace("\\", "")
                    const style = this.keyBoardStyle;
                    switch (s.toLowerCase()) {
                        case "drag":
                            style.width = "50px";
                            break;
                        case "enter":
                            style.width = "60px";
                            break;
                    }
                        


                    return (
                        <kbd style={style} key={kendo.guid()}>
                            {s}
                        </kbd>
                    );
            }
        });

        return (
            <React.Fragment key={kendo.guid()}>
                {el}
            </React.Fragment>);
    }

    private createInfo = (item: ShortCutInfo) => {
        const style: React.CSSProperties = {
            width: "260px",
            flexDirection: "row-reverse",
            display: "flex",
            marginRight: "10px"
        }; 

        return (
            <React.Fragment key={kendo.guid()}>
                <div style={style}>{item.name}</div>
                {this.createShortCut(item.shortcut)}
            </React.Fragment>
        );
    }

    render() {
        const style: React.CSSProperties = {
            display: "flex",
            alignItems: "center",
            margin: "5px",            
            
        }

        const body = this.values.map((item: ShortCutInfo) => {
            return (
                <div key={kendo.guid()} style={style}>
                    {this.createInfo(item)}
                </div>);
        });
        return (
            <>
                {body}
            </>
        );
    }
}

interface ShortCutInfo {    
    name: string;
    shortcut: string;
    visible: boolean|string;
}